import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, ArrowRight } from "lucide-react";

const LOGO = "/bailey-logo.png";

const TIERS = [
  { label: "Ages 0–5", amount: "No charge", note: "Little ones are on the house.", free: true },
  { label: "Ages 6–17", amount: "$100", note: "Kids & teens." },
  { label: "Ages 18–79", amount: "$200", note: "Adults." },
  { label: "Ages 80+", amount: "No charge", note: "Our elders are our guests.", free: true },
  { label: "Guest", amount: "$200", note: "Non-family invited by a Bailey." },
];

export default function ReunionDuesPage() {
  return (
    <div className="min-h-screen bg-[#fdfbf7]" data-testid="reunion-dues-page">
      <header className="max-w-6xl w-full mx-auto px-6 md:px-10 pt-8 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2">
          <img
            src={LOGO}
            alt="Bailey Family Reunion"
            className="h-10 w-10 rounded-full object-cover ring-2 ring-[#1a2947]/10"
          />
          <span className="font-serif text-2xl text-stone-900">Bailey Family Reunion</span>
        </Link>
        <Link
          to="/"
          className="label-eyebrow text-stone-500 hover:text-[#1a2947] flex items-center gap-1"
          data-testid="reunion-dues-back-link"
        >
          <ArrowLeft className="h-4 w-4" /> Back home
        </Link>
      </header>

      <main className="max-w-4xl mx-auto px-6 md:px-10 py-14">
        <div className="text-center mb-12">
          <div className="text-[10px] tracking-[0.16em] uppercase font-semibold text-white bg-[#1a2947] px-3 py-1 rounded-full inline-block mb-4">
            Denver · July 21-23, 2028
          </div>
          <h1 className="font-serif text-4xl md:text-5xl text-stone-900 tracking-tight">
            Reunion Dues
          </h1>
          <p className="text-stone-600 mt-3 max-w-xl mx-auto">
            Dues cover the venue, food, activities, and reunion keepsakes.
            Rates are per person, based on age at the time of the reunion.
          </p>
        </div>

        <div
          className="bg-white border border-[#e6e2d6] rounded-2xl overflow-hidden shadow-[0_20px_60px_-30px_rgba(26,41,71,0.20)]"
          data-testid="reunion-dues-table"
        >
          {TIERS.map((t, i) => (
            <div
              key={t.label}
              className={
                "flex items-center justify-between px-6 md:px-8 py-5 md:py-6 " +
                (i !== TIERS.length - 1 ? "border-b border-[#efeadd]" : "")
              }
              data-testid={`dues-row-${i}`}
            >
              <div>
                <div className="font-serif text-xl md:text-2xl text-stone-900">
                  {t.label}
                </div>
                <div className="text-sm text-stone-500 mt-1">{t.note}</div>
              </div>
              <div
                className={
                  "font-serif text-2xl md:text-3xl tracking-tight " +
                  (t.free ? "text-[#8a7a3a] italic" : "text-[#1a2947]")
                }
                data-testid={`dues-amount-${i}`}
              >
                {t.amount}
              </div>
            </div>
          ))}
        </div>

        <div className="mt-10 flex flex-wrap items-center justify-center gap-3">
          <Link
            to="/payments"
            data-testid="reunion-dues-send-payment"
            className="inline-flex items-center gap-2 rounded-full bg-[#1a2947] text-white font-semibold px-6 py-3 hover:bg-[#0f1a2e] transition-colors"
          >
            Send your payment <ArrowRight className="h-4 w-4" />
          </Link>
        </div>

        <p className="text-center text-xs text-stone-400 mt-8 max-w-lg mx-auto">
          Questions about dues? Reach out to your reunion organizer.
          Dues can be paid via any of the methods on the Send payment page.
        </p>
      </main>
    </div>
  );
}
